import React from "react";

import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Alert from "../../assets/Alert.png";
import dropdownbottom from "../../assets/dropdownbottom.svg";
import BookingEmailConfirmationDialog from "../../components/BookingEmailConfirmationDialog";
import BookingLinkModal from "../../components/BookingLinkModal";
import MarkAsPaidDialog from "../../components/MarkAsPaidDialog";
import { TwPopover } from "../../components/tailwind";
import { useLocalStorage } from "../../hooks";
import { useToast } from "../../provider/ToastProvider";
import { setGlobalLoading } from "../../redux/reducers/loadingReducer";
import { userState } from "../../redux/reducers/userReducer";
import axiosInstance from "../../utils/axiosInstance";
import { getUrlForBookings, getWebshopUrlForEvent } from "../../utils/confighelpers";
import WarningDialog from "../confirmationModals/WarningDialog";
import { useTranslation } from "react-i18next";

export default function ActionPopover({
  bookingDetails,
  handleUpdate,
}) {
  const { addToast, addSuccessToast, addErrorToast, addNotificationDialog } = useToast();
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userReduxState = useSelector(userState);
  const [userToken] = useLocalStorage("userToken");
  const { bookingId } = bookingDetails;
  const username = bookingDetails?.consumer_detail?.username;
  const email = bookingDetails?.consumer_detail?.email;
  const isPaid = ((["free", "paid", "refund-pendding", "refunded", "classpass"].indexOf(bookingDetails?.paymentStatus?.toLowerCase()) > -1) || (["classpass"].indexOf(bookingDetails?.paymentMethod?.toLowerCase()) > -1)) ? true : false;

  const [markAsPaidDialogOpen, setMarkAsPaidDialogOpen] = React.useState(false);
  const [openPatmentProfileWarningDialog, setOpenPatmentProfileWarningDialog] = React.useState(false);
  const [openWarningDialog, setOpenWarningDialog] = React.useState(false);
  const [warningText, setWarningText] = React.useState("");
  const [errorText, setErrorText] = React.useState(false);
  const [bookingLinkModalOpen, setBookingLinkModalOpen] = React.useState(false);
  const [shareLink, setShareLink] = React.useState("false");

  const handleOpenMarkAsPaidDialog = () => {
    setMarkAsPaidDialogOpen(true);
  };
  const handleCloseMarkAsPaidDialog = () => setMarkAsPaidDialogOpen(false);
  const handleOpenWarningDialog = () => {
    setOpenWarningDialog(true);
  };
  const handleCloseWarningDialog = () => setOpenWarningDialog(false);
  const handleOpenErrorDialog = () => {
    addNotificationDialog({
      dialogType: "error",
      dialogTitle: "Error",
      dialogMessage: errorText,
      dialogBtnTitle: t("inputFieldsTitle.ok"),
      dialogBackdropClick: async () => { },
      dialogBtnClick: async () => { }
    })
  };

  const handleBookingLinkModalOpen = () => setBookingLinkModalOpen(true);
  const handleBookingLinkModalClose = () => setBookingLinkModalOpen(false);

  const sendTikkiePromise = async (type) => {

    const body = {
      bookingId,
      forceSendLink: type,
      bookingFor: "Tikkie",
    };
    const config = {
      method: "post",
      url: `${getUrlForBookings()}payments/generateTikkiePmtLink`,
      data: body,
    };
    dispatch(setGlobalLoading(true));
    const request = await axiosInstance(config);
    dispatch(setGlobalLoading(false));
    return request;
  };

  const sendTikkie = async () => {
    const request = await sendTikkiePromise(false);
    if (request.status === 200) {
      if (request.data.statusCode === 417) {
        setErrorText(request.data.message.errors ? t("errors.somethingIsWrong") : request.data.message);
        handleOpenErrorDialog();
      } else if (request.data.statusCode === 406) {
        setWarningText(request.data.message.errors ? t("errors.somethingIsWrong") : request.data.message);
        handleOpenWarningDialog();
      } else if (request.data.statusCode === 403) {
        setWarningText(request.data.message.errors ? t("errors.somethingIsWrong") : request.data.message);
        handleCloseWarningDialog();
        setOpenPatmentProfileWarningDialog(true)
      } else if (request.data.statusCode === 200) {
        setShareLink(request.data.data.generatedUrl);
        handleBookingLinkModalOpen();
      }
    }
  };

  const handleMarkAsPaid = async () => {
    handleCloseMarkAsPaidDialog();

    const body = {
      bookingId,
      paymentStatus: "Paid",
      paymentMode: "Cash",
    };
    const config = {
      method: "put",
      url: `${getUrlForBookings()}payments/updatePaymentStatus`,
      data: body,
    };
    dispatch(setGlobalLoading(true));
    const request = await axiosInstance(config);
    dispatch(setGlobalLoading(false));
    if (request.status === 200) {
      if (request.data.statusCode === 200) {
        addSuccessToast(t("successes.success"));
        handleUpdate();
      } else {
        addErrorToast(request.data.message);
      }
    }
  };

  const getConsumerInfo = () => {
    let consumerDetails = {}

    // if (bookingInfo && bookingInfo?.schedule_class_detail?.participants?.length) {
    //     consumerDetails = bookingInfo?.schedule_class_detail?.participants.find((item) => item?.bookingId === bookingInfo.bookingId)
    // }

    if (bookingDetails) {
      consumerDetails = bookingDetails?.consumer_detail
    }

    return consumerDetails;
  }

  const getTeacherInfo = () => {
    let organizerDetails = {}

    if (bookingDetails) {
      organizerDetails = bookingDetails?.organizer_detail
    }

    return organizerDetails;
  }

  const generatePurchaseOrder = () => {
    let retObj = {};

    if (bookingDetails && bookingDetails?.ticketsBought?.length) {
      bookingDetails?.ticketsBought.forEach((item, i) => {
        retObj['bookingQty' + (i + 1)] = `${item?.bookingQty} x`;
        retObj['ticketType' + (i + 1)] = item?.ticketType;
        retObj['ticketTotalPrice' + (i + 1)] = `€ ${item?.priceToConsumer}`;
      })
    }

    if (bookingDetails && bookingDetails?.addonsBought?.length) {
      bookingDetails?.addonsBought.forEach((item, i) => {
        retObj['addonQty' + (i + 1)] = `${item?.bookingQty} x`;
        retObj['addonName' + (i + 1)] = item?.addonName;
        retObj['addonTotalPrice' + (i + 1)] = `€ ${item?.priceToConsumer}`;
      })
    }

    return retObj
  }

  const calculateServiceFees = () => {
    let serviceFees = 0;

    if (bookingDetails && bookingDetails?.ticketsBought?.length) {
      bookingDetails?.ticketsBought.forEach((item) => {
        // serviceFees = serviceFees + (parseFloat((item?.serviceFee) ? item?.serviceFee : 0) * parseFloat(item?.bookingQty))
        serviceFees = serviceFees + (parseFloat((item?.serviceFee) ? item?.serviceFee : 0))
      })
    }

    if (bookingDetails && bookingDetails?.addonsBought?.length) {
      bookingDetails?.addonsBought.forEach((item) => {
        serviceFees = serviceFees + (parseFloat(item?.serviceFee ? item?.serviceFee : 0) * parseFloat(item?.bookingQty))
      })
    }

    return parseFloat(serviceFees).toFixed(2)
  }

  const calculateTotalPrice = () => {
    let priceToConsumer = 0;
    let serviceFees = 0;

    if (bookingDetails?.totalPriceToConsumer) {
      return parseFloat(bookingDetails?.totalPriceToConsumer || 0).toFixed(2)
    } else {
      if (bookingDetails && bookingDetails?.ticketsBought?.length) {
        bookingDetails?.ticketsBought.forEach((item) => {
          serviceFees = serviceFees + (parseFloat(item?.serviceFee ? item?.serviceFee : 0) * parseFloat(item?.bookingQty))
          priceToConsumer = priceToConsumer + parseFloat(item.priceToConsumer)
        })
      }

      // return parseFloat(priceToConsumer + serviceFees).toFixed(2)
      return parseFloat(priceToConsumer).toFixed(2)
    }
  }

  const sendMail = async () => {

    const body = userReduxState.businessType === "event"
      ? {
          bookingId: bookingDetails?.bookingId,
          bookingType: "event",
        }
      : {
          fromName: getTeacherInfo()?.myBusinessProfile?.businessName,
          toName: getConsumerInfo().fullName,
          toEmail: getConsumerInfo().email,
          bookingType: userReduxState.businessType,
          variables: {
            customer_name: getConsumerInfo().fullName,
            eventOrganizer: getTeacherInfo()?.myBusinessProfile?.businessName,
            ...(generatePurchaseOrder()),
            serviceFee: `€ ${parseFloat(bookingDetails?.totalPlatformServiceFee + bookingDetails?.totalStripePaymentFee).toFixed(2)}`,
            totalPayableAmount: `€ ${calculateTotalPrice()}`,
            paymentMethod: `${bookingDetails?.paymentMethod}`,
            bookingId: `${bookingDetails?.bookingId}`,
            paymentStatus: `${bookingDetails?.paymentStatus}`,
            manageBookingUrl: `${bookingDetails?.manageBookingUrl}`,
            downloadTickets: `${getWebshopUrlForEvent()}get-ticket/${bookingDetails?.manageBookingToken}`,
          }
        };
    const config = {
      method: "post",
      url: `${getUrlForBookings()}sendBookingConfirmation`,
      data: body,
    };
    dispatch(setGlobalLoading(true));
    const request = await axiosInstance(config);
    dispatch(setGlobalLoading(false));
    if (request.status === 200) {
      if (request.data.statusCode === 200) {
        addNotificationDialog({
          dialogType: "success",
          dialogTitle: t("bookings.bookingDetailsSentTitle"),
          dialogMessage: t("bookings.bookingDetailsSentSubTitle", { email: getConsumerInfo()?.email }),
          dialogBtnTitle: t("inputFieldsTitle.ok"),
          dialogBackdropClick: async () => {
          },
          dialogBtnClick: async () => {
          }
        })
        // addSuccessToast(t("successes.success"));
      } else {
        addErrorToast(request.data.message);
      }
    }
  };

  const handleContactClick = () => {
    if (email) {
      window.open(`mailto:${email}`);
    } else {
      const usernameCopy = username;
      const number = usernameCopy.replace(/[^\w\s]/gi, "").replace(/ /g, "");
      window.open(`https://api.whatsapp.com/send?phone=${number}`);
    }
  };

  const popoverOptions = [
    {
      text: t("bookings.markAsPaid"),
      onClick: handleOpenMarkAsPaidDialog,
      disabled: calculateTotalPrice() <= 0 ? true : isPaid,
      icon: Alert,
    },
    {
      text: t("bookings.emailBookingDetails"),
      onClick: sendMail,
      disabled: getConsumerInfo()?.email ? false : true,
      icon: Alert,
    },
    {
      text: t("bookings.downloadBookingDetails"),
      onClick: () => {
        if (bookingDetails?.manageBookingUrl && bookingDetails?.manageBookingUrl !== "") {
          window.open(bookingDetails?.manageBookingUrl, "_blank");
        }
      },
      disabled: bookingDetails?.manageBookingUrl && bookingDetails?.manageBookingUrl !== "" ? false : true,
      icon: Alert,
    },
  ];

  return (

    <div className={"w-full"}>
      <TwPopover
        buttonClassName={"bg-info text-white rounded-lg w-full sm:w-40 p-3"}
        buttonContent={(<span className={"flex flex-row items-center"}>
          <p className={"w-full"}>{t("myEvents.actions")}</p>
          <img src={dropdownbottom} alt={""} />
        </span>)}
      >
        <div className={"flex flex-col divide-y divide-gray-200"}>
          {popoverOptions.map((opt, idx) => (
            <button
              key={idx}
              disabled={opt.disabled}
              // className={`flex flex-row justify-between items-center gap-4 cursor-pointer px-8 py-2 transition-all ${opt.disabled
              //   ? ""
              //   : "active:bg-light-primary active:text-white"
              //   } disabled:opacity-60 disabled:cursor-default`}
              className={`hover:bg-gray-200 p-4 text-sm text-left text-black disabled:text-lilac disabled:opacity-60 disabled:cursor-default`}
              onClick={opt.onClick}
            >
              <p className={"text-sm"}>{opt.text}</p>
            </button>
          ))}
        </div>
      </TwPopover>

      <MarkAsPaidDialog
        open={markAsPaidDialogOpen}
        handleClose={handleCloseMarkAsPaidDialog}
        onSubmit={handleMarkAsPaid}
      />
      <WarningDialog
        open={openWarningDialog}
        text={warningText}
        onClose={handleCloseWarningDialog}
        onSubmit={async () => {

          const request = await sendTikkiePromise(true);
          if (request.status === 200) {
            if (request.data.statusCode === 200) {
              setShareLink(request.data.data.generatedUrl);
              handleBookingLinkModalOpen();
              handleCloseWarningDialog();
            } else if (request.data.statusCode === 403) {
              setWarningText(request.data.message.errors ? t("errors.somethingIsWrong") : request.data.message);
              handleCloseWarningDialog();
              setOpenPatmentProfileWarningDialog(true)
            }
          }
        }}
      />

      <WarningDialog
        open={openPatmentProfileWarningDialog}
        text={t("bookings.enabledYourPaymentSettings")}
        onClose={() => setOpenPatmentProfileWarningDialog(false)}
        onSubmit={async () => {

          navigate("/payment/profile", { replace: true })
        }}
      />
      <BookingLinkModal
        title={t("myEvents.paymentLinkGeneratedTitle", { eventName: bookingDetails?.event_schedule_detail?.eventName })}
        subtitle={t("bookings.paymentLinkGeneratedTitle")}
        open={bookingLinkModalOpen}
        handleClose={handleBookingLinkModalClose}
        bookingLink={shareLink}
      />
    </div>
  );
}
